module.exports = __webpack_public_path__ + "static/customs-declaration-902896fa4a8dd48386818c4d4679dd7a.png";